module.exports = __webpack_public_path__ + "static/media/indigo-sms-tracking.83897814.svg";